import { validateEmailViaAjax } from "./validateEmailViaAjax";

// TODO check if used outside of the skin-foundation. If not - remove
export function checkEmail(email, input) {
  const $input = $(input);
  const $errorContainer = $input.parents(".field").find(".field__error");
  const $successContainer = $input.parents(".field").find(".field__help");
  const $fieldBox = $input.parents(".field__box");
  // Remove text from info area
  $errorContainer.empty().show();
  $successContainer.empty().show();
  // disableSubmitButton();
  validateEmailViaAjax(email, input);
}

function checkEmailInput($emailInput) {
  // This regex is exactly the same as the one used by jquery validator plugin.
  // Thanks to that ajax validation will fire only if the emails has passed regex validation
  const regexEmail = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (regexEmail.test($emailInput.val()) && !$emailInput.data('disable-ajax')) {
    validateEmailViaAjax($emailInput.val(), $emailInput);
  }
}

// validate on pageload - direct AJAX request
$(document).ready(function () {
  const $email = $("#email");
  if ($email.length > 0) {
    if ($email.val()) {
      checkEmailInput($email)
    }
    $email.on("input", function (e) {
      checkEmailInput($email)
    });
  }
});
